import React from "react";

const LoaderOpenAction = ({ cardCount = 5 }) => {
  return (
    <div className="item_loader_actions">
        <div className="item_loader_actions_header"></div>
        <div className="item_loader_actions_body">
            <div className="item_loader_actions_left">

            </div>
            <div className="item_loader_actions_right">

            </div>
        </div>

    </div>
  );
};

export default LoaderOpenAction;